import { call, put, takeEvery } from 'redux-saga/effects';
import { createBikeModel } from '../../requests/create_bike_model_request';
import { createBikeModelRequestSuccess, createBikeModelRequestFailure } from '../actions/create_bike_model.actions';
import { CREATE_BIKE_MODEL_REQUEST } from '../constants/create_bike_model.constants';
import { message_success, message_error } from '../../../../../components/Message';

function* createBikeModelRequest({ params }) {
    const { result, options } = yield call(createBikeModel, params);
    if (result) {
        yield put(createBikeModelRequestSuccess(options));
        message_success('New model created successfully!');
    } else {
        yield put(createBikeModelRequestFailure('Something gone wrong!'));
        message_error('Something gone wrong!');
    }
}

export default function* createBikeModelSaga() {
    yield takeEvery(CREATE_BIKE_MODEL_REQUEST, createBikeModelRequest);
}



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Bike_model_create/redux/sagas/create_bike_model.saga.js